"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

var app_1 = require("../../../config/app");

var FlagIconContainer = styled_components_1.default(react_native_1.View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 28px;\n    height: 20px;\n    position: absolute;\n    left: 14px;\n"], ["\n    width: 28px;\n    height: 20px;\n    position: absolute;\n    left: 14px;\n"])));
var FlagIconPositioner = styled_components_1.default(react_native_1.View)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n"], ["\n    position: relative;\n"])));
var FlagIconBackground = styled_components_1.default(react_native_1.Image)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: 28px;\n    height: 20px;\n    position: absolute;\n    top: 0;\n    left: 0;\n"], ["\n    width: 28px;\n    height: 20px;\n    position: absolute;\n    top: 0;\n    left: 0;\n"])));

exports.FlagIcon = function () {
  return react_1.default.createElement(FlagIconContainer, null, react_1.default.createElement(FlagIconPositioner, null, react_1.default.createElement(FlagIconBackground, {
    source: {
      uri: app_1.appConfig.icons.flagUsCaMixed
    }
  })));
};

var templateObject_1, templateObject_2, templateObject_3;